import React from "react"
import { CodeEditor as JBCodeEditor } from "shared/ui/berry-jass/CodeEditor"

export const CodeEditor = ({ field, form, sx, ...props }) => {
  const { name, value, onBlur } = field
  const onChange = (newValue) => {
    form.setFieldValue(name, newValue)
    form.setFieldTouched(name)
  }

  return (
    <JBCodeEditor
      name={name}
      value={value}
      onBlur={onBlur}
      {...props}
      sx={sx}
      onValueChange={onChange}
    />
  )
}
